// hooks/id-verification-summary.js
import { useMemo } from 'react';

import { countries } from 'constants/countries';
import { countryNameFromAlpha2 } from 'helpers/text';

import { useGetCandidateIdVerificationSummaryQuery } from 'api/candidates-api';

export const useIdVerificationSummary = candidateId => {
  const query = useGetCandidateIdVerificationSummaryQuery(candidateId, { skip: !candidateId });

  const idvStatus = query.data?.idv_status ?? 'pending';
  const idvStatusKey = useMemo(() => `statuses.${idvStatus}`, [idvStatus]);

  const faceSimilarity = query.data?.id_details?.face_similarity ?? null;

  const selfie = query.data?.selfie ?? null;
  const idDoc = query.data?.id_doc ?? null;

  const idDetails = query.data?.id_details ?? {};
  const idDocInfo = useMemo(() => {
    const rawIdType = idDetails.id_type ?? null;
    const formattedIdType = rawIdType
      ? rawIdType
          .toLowerCase()
          .replace(/[_-]/g, ' ')
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      : null;

    return {
      status: idDetails.status ?? null,
      idDocStatusKey: `statuses.${idDetails.status}`,
      faceSimilarity: idDetails.face_similarity ?? null,

      idHolderName: idDetails.id_holder_name ?? null,
      idType: formattedIdType,
      idNumber: idDetails.id_number ?? null,
      idCountryAlpha2: idDetails.id_country ?? null,
      idCountryName: idDetails.id_country
        ? countryNameFromAlpha2(idDetails.id_country, countries)
        : null,
      idExpiry: idDetails.id_expiry ?? null,

      verifiedBy:
        (idDetails.authentication_source ?? null) === 'regula'
          ? (idDoc?.provider ?? null)
          : idDetails.authentication_source,

      authenticationStatus: idDetails.authentication_status ?? null,
      idTypeMatchStatus: idDetails.id_type_match_status ?? null,
      countryMatchStatus: idDetails.country_match_status ?? null,
      expiryToleranceStatus: idDetails.expiry_tolerance_status ?? null,
      nameMatchStatus: idDetails.name_match_status ?? null,
      faceSimilarityStatus: idDetails.face_similarity_status ?? null,
    };
  }, [idDetails]);

  return {
    ...query,
    idvStatus,
    idvStatusKey,
    faceSimilarity,
    selfie,
    idDoc,
    idDocInfo,
  };
};
